import { baseDevConfig,baseProdConfig } from "./baseEnv";

export const stagingConfig = {
  ...baseProdConfig,
  GOOGLE_MAPS_API_KEY: baseDevConfig.GOOGLE_MAPS_API_KEY,
  BACK_API_ENDPOINT_V2: "https://nylhtkae88.execute-api.us-east-2.amazonaws.com/Prod",
  WEB_VIEWER_BASE_URL: "https://webviewer2preview.archformtech.com",
  WEB_EDITOR_BASE_URL: "https://d29iu0sfbeidx.cloudfront.net",
  ARCHFORM_DASH_V1_BASE_URL: "https://dashboard1.archform.com",
  FILE_SUFFIX: "_preview"
}